import { HierarchyContextProps, IHierarchyActionSetHierarchyCommentPanel } from "../interface";

/**
 * Merges comment panel UI state into the current hierarchy state.
 *
 * @param state - The current hierarchy context state.
 * @param action - The set-hierarchy-comment-panel action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_setHierarchyCommentPanel = (
  state: HierarchyContextProps,
  action: IHierarchyActionSetHierarchyCommentPanel,
): HierarchyContextProps => ({
  ...state,
  commentPanelStatus: {
    ...state.commentPanelStatus,
    ...action.commentPanelStatus,
  },
});
